import React from 'react';
import PropTypes from 'prop-types';

var Checklist = function Checklist(_ref) {
  var label = _ref.label,
      name = _ref.name,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      error = _ref.error,
      listData = _ref.listData,
      _onChange = _ref.onChange;

  return React.createElement(
    'div',
    { className: 'checklist-wrapper' },
    React.createElement(
      'label',
      null,
      label
    ),
    React.createElement(
      'div',
      { className: 'checklist' },
      listData.map(function (item, index) {
        return React.createElement(
          'div',
          { key: index, className: 'form-input checkbox ' + className },
          React.createElement(
            'label',
            { htmlFor: name },
            item.label
          ),
          React.createElement('input', {
            type: 'checkbox',
            onChange: function onChange(e) {
              return _onChange(name, item.value);
            },
            className: error && 'error'
          })
        );
      })
    )
  );
};

Checklist.propTypes = {
  /** ListData is a list of objects we use for our checklist */
  listData: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired
  })).isRequired,
  /** Listening for changes */
  onChange: PropTypes.func.isRequired,
  /** This is the label of the item */
  label: PropTypes.string.isRequired,
  /** Css class name */
  className: PropTypes.string
};

export default Checklist;